import { createContext } from "react";

export const DetailFormContext = createContext(null);
export const DetailPageLoadingModalContext = createContext(null);
